import { Grid, Button, Card, CardMedia, Typography, CardActions, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useReducer, useEffect } from 'react';
import { useProjects } from '../../hooks/useProjects';
import UploadImg from '../../assets/images/ui/add-image-wide.png';
import Loader from '../../components/Loader/Loader';
import ProjectTypeFilter from './ProjectTypeFilter';
import {
  createFilterOptions,
  filterReducer,
  filterProjectsByType,
  getSelectedFilters,
} from './projectsReducer';
import { OpalCard, paperStyles } from '../../components/OpalCard/OpalCard';

const Projects = () => {
  const navigate = useNavigate();
  const { projects, loadingProjects, projectsError } = useProjects();

  // Filter state management
  const [filterState, dispatch] = useReducer(filterReducer, {
    filters: [],
  });

  // Initialize filters when projects load
  useEffect(() => {
    if (projects.length > 0) {
      const filterOptions = createFilterOptions(projects);
      dispatch({ type: 'SET_FILTERS', payload: filterOptions });
    }
  }, [projects]);

  // Handle filter toggle
  const handleFilterChange = (filterId) => {
    dispatch({ type: 'TOGGLE_FILTER', payload: filterId });
  };

  // Handle clear all filters
  const handleClearAllFilters = () => {
    dispatch({ type: 'CLEAR_FILTERS' });
  };

  // Get filtered projects
  const selectedTypes = getSelectedFilters(filterState.filters);
  const filteredProjects = filterProjectsByType(projects, selectedTypes);

  return loadingProjects ? (
    <Loader />
  ) : (
    <>
      <Grid container spacing={3} sx={{ marginTop: '0.5rem' }}>
        {projectsError && (
          <Grid item xs={12}>
            <Typography variant="body1" color="error">
              {projectsError}
            </Typography>
          </Grid>
        )}

        {/* Filter Block */}
        <Grid item xs={12}>
          <ProjectTypeFilter
            filters={filterState.filters}
            onFilterChange={handleFilterChange}
            onClearAll={handleClearAllFilters}
          />
        </Grid>

        {/* Projects Count */}
        <Grid item xs={12}>
          <Typography variant="h5" component="h2" color="primary">
            {filteredProjects.length > 0
              ? `Showing ${filteredProjects.length} of ${projects.length} projects`
              : projects.length > 0
                ? 'No projects match the selected filters'
                : 'No projects available'}
          </Typography>
        </Grid>

        {/* Projects Grid */}
        {filteredProjects.map((item) => (
          <Grid item size={{ xs: 12, sm: 3, md: 3 }} key={item._id}>
            <OpalCard>
              <Card sx={{ ...paperStyles, padding: 0, maxWidth: 350, minWidth: 350, width: '100%' }}>
                <CardMedia
                  component="img"
                  alt={item.images[0] ? item.images[0].name : UploadImg}
                  height="200"
                  image={
                    item.images[0]
                      ? item.images[0].path + '?width=350&height=300&crop=fill'
                      : UploadImg
                  }
                />
                <CardContent>
                  <Typography gutterBottom variant="subtitle1" noWrap>
                    {item.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {item.projectType}
                  </Typography>
                  <Typography gutterBottom variant="overline" component="h2">
                    {item.images
                      ? 'Contains ' + item.images.length + ' Images'
                      : 'No Images'}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    onClick={() =>
                      navigate(`/project-edit?id=${item._id}`, {
                        state: { mode: 'edit' },
                      })
                    }
                  >
                    Edit
                  </Button>
                  <Button size="small" color="error">
                    Delete
                  </Button>
                </CardActions>
              </Card>
            </OpalCard>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Projects;